// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3ybFd","column":"style_column__1IvbH","row":"style_row__3eC7A"};